import React from "react";
import { SeatGridStyled } from "./styled";
import { RENDER_SEAT_STATUS } from "utils/functions/seatBooking";

// ผังที่นั่งของหนึ่งโซน: แถวละบรรทัด เรียงตามเลขที่นั่ง
// ถ้าโซนมี col (ตำแหน่งช่องจาก Excel) วางที่นั่งตามช่องนั้นเพื่อเว้นทางเดิน/เยื้องแถวเหมือนผังจริง
// seats: [{ seat_id, row, seat_no, col, status, ... }] (status ตาม SEAT_STATUS)
// selected: array ของ seat_id ที่เลือกอยู่, isSelectable(seat) ตัดสินว่ากดเลือกได้ไหม
// renderTitle(seat): ข้อความ tooltip ตอน hover (เช่น รหัสจอง/ผู้จอง)
const SeatGrid = ({ seats, selected = [], isSelectable, onToggle, onClickSeat, renderTitle }) => {
  const rows = seats.reduce((result, seat) => {
    (result[seat.row] = result[seat.row] || []).push(seat);
    return result;
  }, {});
  const rowNames = Object.keys(rows).sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
  const hasCol = seats.some((seat) => seat.col);
  const positionOf = (seat) => seat.col || seat.seat_no;
  const maxCol = hasCol ? Math.max(...seats.map(positionOf)) : 0;

  return (
    <SeatGridStyled>
      <div className="stage">▲ เวที STAGE</div>
      <div className="grid_wrap">
        {rowNames.map((rowName) => (
          <div
            className={`seat_row${hasCol ? " by_col" : ""}`}
            key={rowName}
            style={hasCol ? { gridTemplateColumns: `28px repeat(${maxCol}, 32px)` } : undefined}
          >
            <div className="row_label">{rowName}</div>
            {rows[rowName]
              .sort((a, b) => a.seat_no - b.seat_no)
              .map((seat) => {
                const status = RENDER_SEAT_STATUS(seat.status);
                const isSelected = selected.includes(seat.seat_id);
                const selectable = isSelectable ? isSelectable(seat) : true;
                return (
                  <button
                    type="button"
                    key={seat.seat_id}
                    className={`seat${isSelected ? " selected" : ""}${selectable ? " selectable" : ""}`}
                    style={{
                      background: status.color,
                      color: status.txtColor,
                      gridColumn: hasCol ? positionOf(seat) + 1 : undefined,
                    }}
                    title={renderTitle ? renderTitle(seat) : `${seat.seat_id} · ${status.label}`}
                    onClick={() => {
                      if (selectable && onToggle) onToggle(seat);
                      else if (onClickSeat) onClickSeat(seat);
                    }}
                  >
                    {seat.seat_no}
                  </button>
                );
              })}
          </div>
        ))}
      </div>
    </SeatGridStyled>
  );
};

export default SeatGrid;
